import { render, staticRenderFns } from "./TableCaixas.vue?vue&type=template&id=660efef8&scoped=true&"
import script from "./TableCaixas.vue?vue&type=script&lang=js&"
export * from "./TableCaixas.vue?vue&type=script&lang=js&"
import style0 from "./TableCaixas.vue?vue&type=style&index=0&id=660efef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660efef8",
  null
  
)

export default component.exports